// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D2ABmzd","account-profile":"_5D2KfIK0","breadcrumbs":"_5D3XIBSJ"};